import TomSelect from 'tom-select';
import { computePosition, autoUpdate, flip, shift, limitShift, offset } from '@floating-ui/dom';

function initSelect(element) {
  const minWidth = element.offsetWidth;
  new TomSelect(element, {
    allowEmptyOption: true,
    controlInput: null,
    copyClassesToDropdown: false,
    wrapperClass: 'select__wrapper',
    controlClass: 'select__control',
    dropdownClass: 'select__dropdown',
    dropdownContentClass: 'select__dropdown-content',
    itemClass: 'select__item',
    optionClass: 'select__option',
    onInitialize: function () {
      // equalize tom-select's width with
      // the original select to prevent FOUC
      this.wrapper.style.minWidth = `${minWidth}px`;
    },
    onDropdownOpen: function () {
      this.autoUpdateCleanup = autoUpdate(this.control, this.dropdown, () => {
        computePosition(this.control, this.dropdown, {
          placement: 'bottom',
          middleware: [offset(4), flip(), shift({ limiter: limitShift() })],
        }).then(({ placement, x, y }) => {
          this.wrapper.setAttribute('data-dropdown-position', placement);
          Object.assign(this.dropdown.style, {
            left: `${x}px`,
            top: `${y}px`,
          });
        });
      });
    },
    onDropdownClose: function () {
      this.autoUpdateCleanup();
    },
  });
}

export function select(selector = '.select__select') {
  setTimeout(() => {
    document.querySelectorAll(selector).forEach((element) => initSelect(element));
  }, 1);
}
